export default {
	namespaced: true,
	state: () => ({
		isMobile: false,
	}),
	mutations: {
		setMobile(state, mobileState) {
			state.isMobile = mobileState;
		},
	},
	getters: {
		mobile: (state) => state.isMobile,
	},
};
